"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockType_Input = void 0;
var BlockType_Input;
(function (BlockType_Input) {
    BlockType_Input["file_uploader_pdf"] = "file_uploader_pdf";
    BlockType_Input["file_uploader_text"] = "file_uploader_text";
    BlockType_Input["file_uploader_audio"] = "file_uploader_audio";
    BlockType_Input["file_uploader_video"] = "file_uploader_video";
    BlockType_Input["file_uploader_image"] = "file_uploader_image";
    BlockType_Input["file_uploader_xlsx"] = "file_uploader_xlsx";
    BlockType_Input["youtube_link"] = "youtube_link";
    BlockType_Input["scheduler"] = "scheduler";
    BlockType_Input["text"] = "text";
})(BlockType_Input || (exports.BlockType_Input = BlockType_Input = {}));
